import React from 'react';
import Joi from "joi-browser";
import { Popover, OverlayTrigger } from "react-bootstrap";
import Phone_textbox from '../../../BprmControls/Phone_textbox';
import SSN_textbox from '../../../BprmControls/SSN_textbox';
import Other_textbox from '../../../BprmControls/Other_textbox';
import { formatPhoneNumber, formatSSNNumber } from '../../../services/appService';
import Controls from '../controlElement/Controls';
import { Box, Button, FormControl, FormHelperText } from '@mui/material';

export default function TextBox(props) {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        stateSchema: schema,
        codeIsVerified,
        isDisabled,
        handleChange,
        handeOnChange,
        getEvaluatedValue
    } = props;

    const getPopover = (notes) => {
        const popover = (
            <Popover id="popover-basic" style={{ minWidth: "500px" }}>
                <Popover.Title as="h4">Rule Expression</Popover.Title>
                <Popover.Content>{notes}</Popover.Content>
            </Popover>
        );
        return (
            <OverlayTrigger trigger="click" placement="top" overlay={popover}>
                <Button variant="outlined" size="small" className="ml-2">
                    <i className="fa fa-eye mr-2"></i>View Rule
                </Button>
            </OverlayTrigger>
        );
    };

    // const handleEncryptDecryptedOnChange = (name, valueArray) => {

    //     const input = { name: name, value: valueArray };
    //     handleChange(input);
    // };

    const handleEncryptDecryptedOnChange = (name, valueArray) => {
        console.log("valueArray", valueArray)
        console.log("name", name)
        let decValue = "";
        for (let index = 0; index < valueArray.length; index++) {
            const element = valueArray[index];
            decValue += element;
        }
        const input = { name: name, value: decValue, type: "text" };
        // console.log("input", input)
        handleChange(input);
    };

    const handePhoneOnChange = ({ target: input }) => {
        input.value = input.value.replace(/[^\d]/g, "");
        if (input.value.length <= 10) handleChange({ name: input.name, value: input.value, type: "text" });
    };

    const handeSsnOnChange = ({ target: input }) => {
        input.value = input.value.replace(/[^\d]/g, "");
        if (input.value.length <= 9) handleChange({ name: input.name, value: input.value, type: "text" });
    };

    let inputType = comp?.attributeDataTypes?.type || "";

    const buildFieldSchema = () => {
        let validator;

        if (["phone", "mobile"].includes(inputType)) {
            validator = Joi.string().length(10);
        } else if (inputType === "ssn") {
            validator = Joi.string().length(9);
        } else if (inputType === "email") {
            validator = Joi.string().email({ tlds: { allow: false } });
        } else {
            // Either provide a generic fallback or throw an error for debugging
            //throw new Error(`Unsupported inputType: ${inputType}`);
            validator = Joi.any();
        }

        // Optional fields
        if (!comp.isRequired) {
            validator = validator.allow('', null);
        }

        // Required fields
        if (comp.isRequired) {
            validator = validator.required();
        }

        // Label
        if (comp.label && comp.label.trim() !== '') {
            validator = validator.label(comp.label);
        } else {
            validator = validator.label('Field'); // fallback default label
        }

        // Optional custom messages for length
        if (["phone", "mobile", "ssn"].includes(inputType)) {
            validator = validator.options({
                language: {
                    string: {
                        length: `${comp.label} must be ${inputType === "ssn" ? 9 : 10} digits.`,
                    },
                },
            });
        }

        //schema[controleId] = validator;
        return validator;
    };


    // // === Joi Validation ===
    // if (["phone", "mobile"].includes(inputType)) {
    //     schema[controleId] = Joi.string()
    //         .length(10)
    //         .allow('',null) // <-- allow empty string if not required
    //         .required(!!comp.isRequired)
    //         .options({
    //             language: {
    //                 string: {
    //                     length: `${comp.label} must be 10 digits.`,
    //                 },
    //             },
    //         })
    //         .label(comp.label);
    // }

    // if (inputType === "ssn") {
    //     schema[controleId] = Joi.string()
    //         .length(9)
    //         .allow('',null) // <-- allow empty string if not required
    //         .required(!!comp.isRequired)
    //         .options({
    //             language: {
    //                 string: {
    //                     length: `${comp.label} must be 9 digits.`,
    //                 },
    //             },
    //         })
    //         .label(comp.label);
    // }

    // if (inputType === "email") {
    //     schema[controleId] = Joi.string()
    //         .email({ tlds: { allow: false } }) // disable TLD restriction if needed
    //         .allow('',null) // allow empty string when not required
    //         .required(!!comp.isRequired)
    //         .label(comp.label);
    // }

    // Usage
    schema[controleId] = buildFieldSchema();

    const error = errors[controleId];

    return (
        <Box mb={2}>
            {comp?.encryptionValidate ? (
                <>
                    {inputType === "ssn" && (
                        <SSN_textbox
                            value={data[controleId] || ""}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}

                    {["phone", "mobile"].includes(inputType) && (
                        <Phone_textbox
                            value={data[controleId] || ""}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}

                    {(inputType === "" || inputType === "email" || inputType === "number") && (
                        <Other_textbox
                            value={data[controleId] || ""}
                            label={comp.label}
                            isDisabled={isDisabled}
                            name={controleId}
                            handleOnChange={handleEncryptDecryptedOnChange}
                            codeIsVerified={codeIsVerified}
                            errors={errors}
                            required={comp.isRequired}
                            cssclass={comp?.cssclass}
                        />
                    )}
                </>
            ) : (
                <FormControl fullWidth variant="outlined" error={!!error}>
                    {(inputType === "ssn") && (
                        <Controls.Input
                            required={comp.isRequired}
                            name={controleId}
                            label={comp.label}
                            value={formatSSNNumber(data[controleId] || "")}
                            onChange={handeSsnOnChange}
                            disabled={isDisabled}
                            className={comp?.cssclass || ""}
                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#555555",
                                    color: "#555555",
                                    opacity: 0.9,
                                },
                                "& .MuiInputLabel-root.Mui-disabled": {
                                    color: "#333333",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}

                    {["phone", "mobile"].includes(inputType) && (
                        <Controls.Input
                            required={comp.isRequired}
                            name={controleId}
                            label={comp.label}
                            value={formatPhoneNumber(data[controleId] || "")}
                            onChange={handePhoneOnChange}
                            disabled={isDisabled}
                            className={comp?.cssclass || ""}
                            sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#555555",
                                    color: "#555555",
                                    opacity: 0.9,
                                },
                                "& .MuiInputLabel-root.Mui-disabled": {
                                    color: "#333333",
                                    opacity: 1,
                                },
                            }}
                        />
                    )}

                    {(inputType === "" || inputType === "email" || inputType === "number") && (
                        <>
                            <Controls.Input
                                required={comp.isRequired}
                                name={controleId}
                                label={comp.label}
                                type={inputType === "number" ? "number" : "text"}
                                value={data[controleId] || ""}
                                onChange={(event) => handeOnChange({ target: { name: controleId, value: event.target.value, type: "text" } })}
                                disabled={isDisabled || controleId === "candidateonboardingform.Rate_hour_Paid_to_Candidate"}
                                readOnly={!!comp?.rule}
                                className={comp?.cssclass || ""}
                                sx={{
                                    "& .MuiInputBase-input.Mui-disabled": {
                                        WebkitTextFillColor: "#555555",
                                        color: "#555555",
                                        opacity: 0.9,
                                    },
                                    "& .MuiInputLabel-root.Mui-disabled": {
                                        color: "#333333",
                                        opacity: 1,
                                    },
                                }}
                            />
                            {comp?.rule && (
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => getEvaluatedValue(comp)}

                                    sx={{
                                        mt: 1,
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            WebkitTextFillColor: "#555555",
                                            color: "#555555",
                                            opacity: 0.9,
                                        },
                                        "& .MuiInputLabel-root.Mui-disabled": {
                                            color: "#333333",
                                            opacity: 1,
                                        },
                                    }}
                                >
                                    Apply Rule
                                </Button>
                            )}
                        </>
                    )}

                    {error && <FormHelperText>{error}</FormHelperText>}
                </FormControl>
            )}

            {/* View Rule Button */}
            {comp?.rule && getPopover(comp.ruleExpression)}
        </Box>
    );
}
